import { updateUserStreamQualityPreference } from '@/lib/api';
import { useAuthContext } from '@/lib/contexts/auth';

import type { TrackFileType } from '@/lib/api';

export const useStreamingPreferences = () => {
  const { getUserDataField } = useAuthContext();

  return {
    getStreamingPreference: () =>
      getUserDataField(user => user.stream_quality_web) as TrackFileType,
    setStreamingPreference: (format: TrackFileType) =>
      updateUserStreamQualityPreference(format),
  };
};
